// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown__UW3h0","show-share-button":"show-share-button__5KrEK","icon":"icon__Dc1zv","link":"link__Z4Pp7","name":"name__iY5Yb","project-status":"project-status__r9NHQ"};